import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import { isTreatmentRateAvailable } from "../campaignFormatUtils";

const CampaignAlertsProgressBar = ({
  treated,
  total,
  percent,
  campaignStop,
}) => {
  const { t } = useTranslation();

  const safeTotal = total ?? 0;
  const safeTreated = treated ?? 0;
  const showTreatmentRate = isTreatmentRateAvailable(campaignStop);
  const safePercent =
    showTreatmentRate && percent != null && !Number.isNaN(Number(percent))
      ? Math.min(100, Math.max(0, Math.round(Number(percent))))
      : null;

  return (
    <div className="campaign-progress-alerts-card">
      <div className="flex items-center gap-1.5 mb-2">
        <h3
          className="campaign-progress-alerts-card__title"
          style={{ marginBottom: 0 }}
        >
          {t("campaign.progressAlertsTitle")}
        </h3>
        {showTreatmentRate ? (
          <Tooltip
            title={t("campaign.progressAlertsCutoffTooltip")}
            arrow
            placement="top"
          >
            <span
              className="inline-flex cursor-help text-[#5e5e5e]"
              aria-label={t("campaign.progressAlertsCutoffTooltip")}
            >
              <InfoOutlinedIcon sx={{ fontSize: 16 }} />
            </span>
          </Tooltip>
        ) : null}
      </div>
      <p className="campaign-progress-alerts-card__count">
        {safeTreated} / {safeTotal}
      </p>
      {safePercent != null ? (
        <div className="campaign-progress-alerts-card__bar-row">
          <div className="campaign-progress-alerts-card__bar">
            <div
              className="campaign-progress-alerts-card__bar-fill"
              style={{ width: `${safePercent}%` }}
            />
          </div>
          <span className="campaign-progress-alerts-card__percent">
            {safePercent}%
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default CampaignAlertsProgressBar;
